import { render, staticRenderFns } from "./uploadImgs3.vue?vue&type=template&id=18b69ec0&scoped=true&"
import script from "./uploadImgs3.vue?vue&type=script&lang=js&"
export * from "./uploadImgs3.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgs3.vue?vue&type=style&index=0&id=18b69ec0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b69ec0",
  null
  
)

export default component.exports